import { useState } from "react";
import SelectInput from "../externalComponents/tailwind/select-input";
import "./delay-picker.css";

export const DelayPicker = ({ delay, delayChanged, invalid }) => {
  const [selectedDays, setSelectedDays] = useState(0);
  const [selectedHours, setSelectedHours] = useState(0);
  const [selectedMinutes, setSelectedMinutes] = useState(0);

  const days = Math.floor(delay / 1440);
  const remainingMinutes = delay % 1440;
  const hours = Math.floor(remainingMinutes / 60);
  const minutes = remainingMinutes % 60;

  const handleDaysSelectedChange = (value) => {
    const intValue = parseInt(value, 10);
    setSelectedDays(intValue);
    delayChanged(
      intValue * 1440 +
        (selectedHours || hours) * 60 +
        (selectedMinutes || minutes),
    );
  };

  const handleHoursSelectedChange = (value) => {
    const intValue = parseInt(value, 10);
    setSelectedHours(intValue);
    delayChanged(
      (selectedDays || days) * 1440 +
        intValue * 60 +
        (selectedMinutes || minutes),
    );
  };

  const handleMinutesSelectedChange = (value) => {
    const intValue = parseInt(value, 10);
    setSelectedMinutes(intValue);
    delayChanged(
      (selectedDays || days) * 1440 + (selectedHours || hours) * 60 + intValue,
    );
  };

  const daysList = Array.from({ length: 366 }, (_, i) => ({
    label: `${i} days`,
    value: i,
  }));
  const hoursList = Array.from({ length: 24 }, (_, i) => ({
    label: `${i} hours`,
    value: i,
  }));
  const minutesList = Array.from({ length: 60 }, (_, i) => ({
    label: `${i} minutes`,
    value: i,
  }));

  return (
    <>
      <div className="delay-picker-wrapper">
        <SelectInput
          options={daysList}
          value={selectedDays || days}
          selected={selectedDays || days}
          invalid={invalid}
          onChange={handleDaysSelectedChange}
        />

        <SelectInput
          options={hoursList}
          value={selectedHours || hours}
          selected={selectedHours || hours}
          invalid={invalid}
          onChange={handleHoursSelectedChange}
        />

        <SelectInput
          options={minutesList}
          value={selectedMinutes || minutes}
          selected={selectedMinutes || minutes}
          invalid={invalid}
          onChange={handleMinutesSelectedChange}
        />
      </div>
    </>
  );
};
